import { Badge, Flex, Text, useColorModeValue } from '@chakra-ui/react';
import Card from 'components/card/Card';
import { useTranslation } from 'react-i18next';

interface PlanStat {
  planName: string;
  count: number;
}

interface Props {
  planStats: PlanStat[];
}

export default function PlanDistributionCard({ planStats }: Props) {
  const { t } = useTranslation();
  const textColor = useColorModeValue('secondaryGray.900', 'white');

  return (
    <Card p="20px" flex="1" minW="300px">
      <Text color={textColor} fontSize="lg" fontWeight="700" mb="16px">
        {t('dashboard.plan_distribution')}
      </Text>
      {planStats.map((p) => (
        <Flex
          key={p.planName}
          justify="space-between"
          align="center"
          py="8px"
          borderBottom="1px solid"
          borderColor="gray.100"
        >
          <Text color={textColor} fontSize="sm" fontWeight="600">
            {p.planName}
          </Text>
          <Badge colorScheme="brand" fontSize="xs">
            {p.count} businesses
          </Badge>
        </Flex>
      ))}
      {planStats.length === 0 && (
        <Text color="gray.400">{t('dashboard.no_data')}</Text>
      )}
    </Card>
  );
}
